import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { changeLanguage } from '../../i18n/config';
import { pathForLocale, type SupportedLocale } from '../../i18n/path-locale';

interface LanguageToggleProps {
  variant?: 'light' | 'dark';
}

export const LanguageToggle: React.FC<LanguageToggleProps> = ({ variant = 'light' }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const currentLang = i18n.language?.startsWith('fr') ? 'fr' : 'en';

  const toggle = (lang: SupportedLocale) => {
    changeLanguage(lang);
    const nextPath = pathForLocale(location.pathname, lang);
    if (nextPath !== location.pathname) {
      navigate(nextPath);
    }
  };

  const isLight = variant === 'light';

  return (
    <div className={`inline-flex items-center rounded-full p-0.5 text-xs font-semibold ${
      isLight ? 'bg-gray-100' : 'bg-white/15'
    }`}>
      <button
        onClick={() => toggle('en')}
        className={`px-3 py-2 min-h-[44px] min-w-[44px] rounded-full transition-colors border-none cursor-pointer flex items-center justify-center ${
          currentLang === 'en'
            ? isLight ? 'bg-white text-gray-900 shadow-sm' : 'bg-white text-gray-900'
            : isLight ? 'bg-transparent text-gray-500 hover:text-gray-700' : 'bg-transparent text-white/70 hover:text-white'
        }`}
      >
        EN
      </button>
      <button
        onClick={() => toggle('fr')}
        className={`px-3 py-2 min-h-[44px] min-w-[44px] rounded-full transition-colors border-none cursor-pointer flex items-center justify-center ${
          currentLang === 'fr'
            ? isLight ? 'bg-white text-gray-900 shadow-sm' : 'bg-white text-gray-900'
            : isLight ? 'bg-transparent text-gray-500 hover:text-gray-700' : 'bg-transparent text-white/70 hover:text-white'
        }`}
      >
        FR
      </button>
    </div>
  );
};
